/* eslint-disable react/prop-types */
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

const ToolTipButton = ({
  label,
  children,
  placement = 'bottom',
  ...buttonProps
}) => {
  return (
    <OverlayTrigger placement={placement} overlay={<Tooltip>{label}</Tooltip>}>
      <Button {...buttonProps}>{children}</Button>
    </OverlayTrigger>
  );
};

export default ToolTipButton;
